import { api } from "../../services";

const products = {
  // namespaced: true,
  state: {
    board_view_enabled: false,
    current_product: {
      name: null,
      internal_code: null,
      price: 0,
      status_key: true,
      type_key: 0,
      description: null,
      channel_id: null,
      department_id: null,
      created_at: "",
      updated_at: "",
      deleted_at: "",
      created: "",
      amount: null,
      user_id: null,
      product_category_id: null,
      product_brand_id: null,
      product_supplier_id: null,
      shipping: 0,
      max_discount: 0,
      taxes: 0,
      profit_margin: 0,
      purchase_price: 0,
      cost_price: 0
    },
    fields_search:{
      channel_id: 0,
      department_id: 0,
      product_category_id: 0,
      product_brand_id: 0,
      product_supplier_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    model_fields_search: {
      // channel_id: 0,
      department_id: 0,
      product_category_id: 0,
      product_brand_id: 0,
      product_supplier_id: 0,
      user_id: 0,
      status_key: 0,
      start_date: "",
      expiration_date: "",
      lead_name: "",
      lead_phone: "",
    },
    current_filter: {
      channel_id: null,
      department_id: null,
      q:null
    },
    modals: {
      initial_filter: false,
      new_product: false,
      edit_product: false,
      confirm_delete_product: false,
    },
    data: [],
    pagination: [],
    departments_available: []
  },
  getters: {
    getProductById: state => payload => {
      return state.data.find(product => {
        return product.id == payload.id;
      });
    },
    filterDepartmentsAvailableOnProducts: state => (key, value) => {
      if (state.departments_available !== undefined) {
        return state.departments_available.filter(item => {
          return item[`${key}`] === value;
        });
      }
      return [];
    }
  },
  mutations: {
    SET_DATA_VALUE(state, payload) {
      state.pagination = payload;
    }
  },
  actions: {
    async getAllProducts(context, fields_search) {
      await api.get("/products", {
        params: fields_search
      }).then((response) => {
        context.commit("SET_DATA_VALUE", response.data);
      });
    },
    async deleteProduct(context, payload) {
      payload.status_key = 0;
      await api.delete(`/products/${payload.id}`, payload).then(async () => {
        await context.dispatch("getAllProducts", {
          channel_id: payload.channel_id,
          department_id: payload.department_id
        });
      });
    },
    async updateProduct(context, payload) {
      await api.put(`/products/${payload.id}`, payload).then(async () => {
        await context.dispatch("getAllProducts", {
          channel_id: payload.channel_id,
          department_id: payload.department_id
        });
      });
    },
    async createProduct(context, payload) {
      await api.post("/products", payload).then(async () => {
        await context.dispatch("getAllProducts", {
          channel_id: payload.channel_id,
          department_id: payload.department_id
        });
      });
    }
  }
};

export default products;
